"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.ascitesMessages = exports.encephalopathyGradeMessages = exports.dialysisAtLeastTwicePerWeekMessages = exports.Ascites = exports.EncephalopathyGrade = exports.DialysisAtLeastTwicePerWeek = void 0;
const schema_1 = require("../../schema");
var DialysisAtLeastTwicePerWeek;
(function (DialysisAtLeastTwicePerWeek) {
    DialysisAtLeastTwicePerWeek["YES"] = "YES";
    DialysisAtLeastTwicePerWeek["NO"] = "NO";
})(DialysisAtLeastTwicePerWeek || (exports.DialysisAtLeastTwicePerWeek = DialysisAtLeastTwicePerWeek = {}));
var EncephalopathyGrade;
(function (EncephalopathyGrade) {
    EncephalopathyGrade["GRADE_0"] = "GRADE_0";
    EncephalopathyGrade["GRADE_I"] = "GRADE_I";
    EncephalopathyGrade["GRADE_II"] = "GRADE_II";
    EncephalopathyGrade["GRADE_III"] = "GRADE_III";
    EncephalopathyGrade["GRADE_IV"] = "GRADE_IV";
})(EncephalopathyGrade || (exports.EncephalopathyGrade = EncephalopathyGrade = {}));
var Ascites;
(function (Ascites) {
    Ascites["NONE"] = "NONE";
    Ascites["MILD_MODERATE"] = "MILD_MODERATE";
    Ascites["SEVERE"] = "SEVERE";
})(Ascites || (exports.Ascites = Ascites = {}));
exports.dialysisAtLeastTwicePerWeekMessages = {
    [DialysisAtLeastTwicePerWeek.YES]: {
        id: "ltx.scores.dialysisAtLeastTwicePerWeek.YES",
        defaultMessage: "Igen"
    },
    [DialysisAtLeastTwicePerWeek.NO]: {
        id: "ltx.scores.dialysisAtLeastTwicePerWeek.NO",
        defaultMessage: "Nem"
    }
};
exports.encephalopathyGradeMessages = {
    [EncephalopathyGrade.GRADE_0]: {
        id: "ltx.scores.encephalopathyGrade.GRADE_0",
        defaultMessage: "Nincs"
    },
    [EncephalopathyGrade.GRADE_I]: {
        id: "ltx.scores.encephalopathyGrade.GRADE_I",
        defaultMessage: "Grade I"
    },
    [EncephalopathyGrade.GRADE_II]: {
        id: "ltx.scores.encephalopathyGrade.GRADE_II",
        defaultMessage: "Grade II"
    },
    [EncephalopathyGrade.GRADE_III]: {
        id: "ltx.scores.encephalopathyGrade.GRADE_III",
        defaultMessage: "Grade III"
    },
    [EncephalopathyGrade.GRADE_IV]: {
        id: "ltx.scores.encephalopathyGrade.GRADE_IV",
        defaultMessage: "Grade IV"
    }
};
exports.ascitesMessages = {
    [Ascites.NONE]: {
        id: "ltx.scores.ascites.NONE",
        defaultMessage: "Nincs"
    },
    [Ascites.MILD_MODERATE]: {
        id: "ltx.scores.ascites.MILD_MODERATE",
        defaultMessage: "Enyhe-közepes"
    },
    [Ascites.SEVERE]: {
        id: "ltx.scores.ascites.SEVERE",
        defaultMessage: "Súlyos (refrakter)"
    }
};
const creatinine = schema_1.Schema.number()
    .expiration(15552000)
    .unit("umol/L")
    .precision(2)
    .min(1)
    .max(1000)
    .interpretation({ vocab: "ltx", code: "score_creatinine" })
    .tag({ vocab: "snomed", code: "113075003" })
    .tag({ vocab: "loinc", code: "2160-0" });
const bilirubinTotal = schema_1.Schema.number()
    .expiration(15552000)
    .unit("umol/L")
    .precision(2)
    .min(0)
    .max(500)
    .interpretation({ vocab: "ltx", code: "score_bilirubin_total" })
    .tag({ vocab: "snomed", code: "359986008" })
    .tag({ vocab: "loinc", code: "14631-6" });
const albumin = schema_1.Schema.number()
    .unit("g/L")
    .precision(1)
    .min(5)
    .max(90)
    .interpretation({ vocab: "ltx", code: "score_albumin" })
    .tag({ vocab: "loinc", code: "1751-7" });
const inr = schema_1.Schema.number()
    .expiration(15552000)
    .precision(2)
    .min(0.5)
    .max(20)
    .interpretation({ vocab: "ltx", code: "score_inr" })
    .tag({ vocab: "snomed", code: "1951000175101" })
    .tag({ vocab: "loinc", code: "34714-6" });
const natrium = schema_1.Schema.number()
    .expiration(15552000)
    .unit("mmol/L")
    .precision(2)
    .min(100)
    .max(160)
    .interpretation({ vocab: "ltx", code: "score_natrium" })
    .tag({ vocab: "snomed", code: "312469006" })
    .tag({ vocab: "loinc", code: "2947-0" });
const dialysisAtLeastTwicePerWeek = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DialysisAtLeastTwicePerWeek.YES),
    schema_1.Schema.singleChoiceItem(DialysisAtLeastTwicePerWeek.NO)
]).interpretation({ vocab: "ltx", code: "dialysis_at_least_twice_per_week" });
const encephalopathyGrade = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(EncephalopathyGrade.GRADE_0),
    schema_1.Schema.singleChoiceItem(EncephalopathyGrade.GRADE_I),
    schema_1.Schema.singleChoiceItem(EncephalopathyGrade.GRADE_II),
    schema_1.Schema.singleChoiceItem(EncephalopathyGrade.GRADE_III),
    schema_1.Schema.singleChoiceItem(EncephalopathyGrade.GRADE_IV)
]).interpretation({ vocab: "ltx", code: "score_encephalopathy_grade" });
const ascites = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Ascites.NONE),
    schema_1.Schema.singleChoiceItem(Ascites.MILD_MODERATE),
    schema_1.Schema.singleChoiceItem(Ascites.SEVERE)
]).interpretation({ vocab: "ltx", code: "ascites_child_pugh" });
const meldScore = schema_1.Schema.expression(`toPrecision(Math.min(40, Math.max(6, Math.round(10 * (0.957 * Math.log(Math.max(1, ({../dialysisAtLeastTwicePerWeek} === "YES" ? 4 : Math.min(4, {../creatinine} / 88.4)))) + 0.378 * Math.log(Math.max(1, {../bilirubinTotal} / 17.1)) + 1.12  * Math.log(Math.max(1, {../inr}))) + 6.43))),0)`).interpretation({ vocab: "ltx", code: "meld_score" });
const meldNaScore = schema_1.Schema.expression(`toPrecision(Math.min(40, Math.max(6, Math.round(Math.min(40, Math.max(6, Math.round(10 * (0.957 * Math.log(Math.max(1, ({../dialysisAtLeastTwicePerWeek} === "YES" ? 4 : Math.min(4, {../creatinine} / 88.4)))) + 0.378 * Math.log(Math.max(1, {../bilirubinTotal} / 17.1)) + 1.12 * Math.log(Math.max(1, {../inr}))) + 6.43))) + 1.32 * (137 - Math.min(137, Math.max(125, {../natrium}))) - 0.033 * Math.min(40, Math.max(6, Math.round(10 * (0.957 * Math.log(Math.max(1, ({../dialysisAtLeastTwicePerWeek} === "YES" ? 4 : Math.min(4, {../creatinine} / 88.4)))) + 0.378 * Math.log(Math.max(1, {../bilirubinTotal} / 17.1)) + 1.12 * Math.log(Math.max(1, {../inr}))) + 6.43))) * (137 - Math.min(137, Math.max(125, {../natrium})))))),0)`).interpretation({ vocab: "ltx", code: "meld_na_score" });
const childPughScore = schema_1.Schema.expression(`toPrecision(({../bilirubinTotal} < 34 ? 1 : {../bilirubinTotal} <= 50 ? 2 : 3) + ({../albumin} > 35 ? 1 : {../albumin} >= 28 ? 2 : 3) + ({../inr} < 1.7 ? 1 : {../inr} <= 2.3 ? 2 : 3) + ({../ascites} === "NONE" ? 1 : {../ascites} === "MILD_MODERATE" ? 2 : 3) + ({../encephalopathyGrade} === "GRADE_0" ? 1 : ({../encephalopathyGrade} === "GRADE_I" || {../encephalopathyGrade} === "GRADE_II") ? 2 : 3),0)`).interpretation({ vocab: "ltx", code: "child_pugh_score" });
const childPughClass = schema_1.Schema.expression(`((({../bilirubinTotal} < 34 ? 1 : {../bilirubinTotal} <= 50 ? 2 : 3) + ({../albumin} > 35 ? 1 : {../albumin} >= 28 ? 2 : 3) + ({../inr} < 1.7 ? 1 : {../inr} <= 2.3 ? 2 : 3) + ({../ascites} === "NONE" ? 1 : {../ascites} === "MILD_MODERATE" ? 2 : 3) + ({../encephalopathyGrade} === "GRADE_0" ? 1 : ({../encephalopathyGrade} === "GRADE_I" || {../encephalopathyGrade} === "GRADE_II") ? 2 : 3)) <= 6 ? "A" : (({../bilirubinTotal} < 34 ? 1 : {../bilirubinTotal} <= 50 ? 2 : 3) + ({../albumin} > 35 ? 1 : {../albumin} >= 28 ? 2 : 3) + ({../inr} < 1.7 ? 1 : {../inr} <= 2.3 ? 2 : 3) + ({../ascites} === "NONE" ? 1 : {../ascites} === "MILD_MODERATE" ? 2 : 3) + ({../encephalopathyGrade} === "GRADE_0" ? 1 : ({../encephalopathyGrade} === "GRADE_I" || {../encephalopathyGrade} === "GRADE_II") ? 2 : 3)) <= 9 ? "B" : "C")`).interpretation({
    vocab: "ltx",
    code: "calculated_child_pugh_classification"
});
exports.validator = schema_1.Schema.object().default({}).sealed(true).properties({
    creatinine,
    bilirubinTotal,
    albumin,
    inr,
    natrium,
    dialysisAtLeastTwicePerWeek,
    encephalopathyGrade,
    ascites,
    meldScore,
    meldNaScore,
    childPughScore,
    childPughClass
});
